import { Component, Input } from "@angular/core";
import { FormGroup } from "@angular/forms";

export interface FieldMapping {
  source: string;
  target: string;
}

@Component({
  selector: "app-copy-fields-checkbox",
  templateUrl: "./copy-fields-checkbox.component.html",
  standalone: false,
})
export class CopyFieldsCheckboxComponent {
  @Input() parentForm: FormGroup;
  @Input() fieldMappings: FieldMapping[] = [];
  @Input() checkboxLabel: string = "Copy information from above";

  isCopied: boolean = false;

  onCopyChange(checked: boolean) {
    this.isCopied = checked;

    if (checked) {
      this.fieldMappings.forEach(({ source, target }) => {
        const value = this.parentForm?.get(source)?.value ?? "";
        this.parentForm?.get(target)?.setValue(value);
      });
    } else {
      this.fieldMappings.forEach(({ target }) => {
        this.parentForm?.get(target)?.setValue("");
      });
    }
  }
}
